

import Editor from './Editor';
import Tool from './Tool';
import NodeLayer from './NodeLayer';
import Layer from './Layer';
import ConnectionLayer from './ConnectionLayer';

export default class DeleteLayerTool extends Tool {

    public constructor(editor: Editor) {
        super(editor, "delete_node")
    }

   
    public handleDelete(): boolean {

        if(document.activeElement.tagName != 'BODY') {
            return;
        }

        var selectedLayer = this.editor.selectedLayer;
        if(selectedLayer == null) {
            return;
        }

        var deletedLayers = new Array<Layer>();
        deletedLayers.push(selectedLayer);

        if(selectedLayer instanceof NodeLayer) {

            for(var conn of selectedLayer.outgoingConnections) {
                deletedLayers.push(conn);
            }

            for(var conn of selectedLayer.incomingConnections) {
                deletedLayers.push(conn);
            }
        }

        for(var del of deletedLayers) {
            this.editor.rootLayerGroup.removeLayer(del);
            if(del instanceof ConnectionLayer) {
                del.startNode.removeOutgoingConnection(del);
                del.endNode.removeIncomingConnection(del);
            }
        }

        if(this.editor.startLayer == selectedLayer) {
            this.editor.setStartLayer(null);
        }

        this.editor.setSelectedLayer(null);
       
        return true;
    }

    
}